import React, { useEffect, useState } from "react";
import {
  ErrataWidget,
  Icon,
  WidgetFrame,
} from "../../../personal-studio-components/studio";
import { useSelector } from "react-redux";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { add_attachment, update_attachment } from "./api";
import { StudentService } from "../../components/studentService";
import * as cls from "./sabbatical.module.scss";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
import Loader from "../../components/loader/Loader";
import SinglePage from "../../components/attachmentPages/SinglePage.jsx";
import { Alert, Snackbar } from "@mui/material";
import LinearLoader from "../../components/linearLoader/LinearLoader.jsx";

function AcademicVacation() {
  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const [isCalendarShow, setIsCalendarShow] = useState(false);
  const [reasons, setReasons] = useState(null);
  const [explanations, setExplanations] = useState(null);
  const [reasonId, setReasonId] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [requiredDoc, setRequiredDocs] = useState(null);
  const [stateData, setStateData] = useState(null);
  const [response, setResponse] = useState(null);
  const [allowedStartDates, setAllowedStartDates] = useState(null);
  const [allowedEndDates, setAllowedEndDates] = useState(null);
  const [loadState, setLoadState] = useState(null);
  const [statementLoading, setStatementLoading] = useState(false);
  const [dates, setDates] = useState(null);
  const [explanationId, setExplanationId] = useState("");
  const [explanationCommentValue, setExplanationCommentValue] = useState("");
  const [fileUploadLoadingIds, setFileUploadLoadingIds] = useState(null);
  const [createEventBtnLoading, setCreateEventBtnLoading] = useState(false);
  const [isSaveMandatory, setIsSaveMandatory] = useState(false);
  const [activeStartMonth, setActiveStartMonth] = useState(new Date());
  const [activeEndMonth, setActiveEndMonth] = useState(new Date());
  // const [mandatoryDocsLoaded, setMandatoryDocLoaded] = useState(false);
  // const [errors, setErrors] = useState(null);
  const disabled =
    stateData?.event_status_id === 15 || stateData?.event_status_id === 16;

  async function getCertificatesMenu() {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/academic/load",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      const data = await StudentService.send(request, setResponse);
      setResponse(data);
      if (!data.errors) {
        const reasons = Object.values(data.reasons);
        reasons.sort((a, b) => a.order_number - b.order_number);
        setReasons(reasons);
        if (Object.values(data.academic_leave_event).length > 0) {
          const {
            study_contract_history,
            reason_explanation_id,
            reason_explanation_comment,
            event_status_id,
          } = data.academic_leave_event.full_event_details.academic_leave_event;
          setStateData({
            ...data,
            current_document_reason_id:
              study_contract_history.document_reason_id,
            event_status_id,
          });

          if (study_contract_history) {
            const someIsNull = Object.values(study_contract_history).some(
              (el) => el === null,
            );
            if (someIsNull) {
              setIsSaveMandatory(true);
            } else {
              setIsSaveMandatory(false);
            }
          }
          if (study_contract_history.document_reason_id) {
            await getStartDates(study_contract_history.document_reason_id);
          }
          if (study_contract_history.document_reason_id) {
            await getDocumentList(
              study_contract_history.document_reason_id,
              data,
            );
          }
          if (study_contract_history.start_date) {
            setDates((prev) => ({
              ...prev,
              start_date: study_contract_history.start_date,
            }));
          }
          if (study_contract_history.end_date) {
            setDates((prev) => ({
              ...prev,
              end_date: study_contract_history.end_date,
            }));
          }
          if (study_contract_history.start_date) {
            setStartDate(new Date(study_contract_history.start_date));
          }
          if (study_contract_history.end_date) {
            setEndDate(new Date(study_contract_history.end_date));
          }
          setReasonId(study_contract_history.document_reason_id);
          if (reason_explanation_id) {
            const selectedReason = reasons.find(
              (reason) =>
                reason.document_reason_id ==
                study_contract_history.document_reason_id,
            );
            const selectedExplanation_id = selectedReason.explanations.find(
              (explanation) =>
                explanation.explanation_id == reason_explanation_id,
            );
            setExplanationId(JSON.stringify(selectedExplanation_id));
            setExplanations(selectedReason.explanations);
            setStateData((prev) => {
              return {
                ...prev,
                ...data,
                explanation_id: reason_explanation_id,
                explanation_comment_needed:
                  selectedExplanation_id.explanation_comment_needed,
              };
            });
          }
          if (reason_explanation_comment) {
            setStateData((prev) => {
              return {
                ...prev,
                explanation_comment_needed: true,
              };
            });
            setExplanationCommentValue(reason_explanation_comment);
          }
        } else {
          setStateData(data);
        }
      }
    }
  }

  async function getStartDates(current_document_reason_id) {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/academic/start_dates",
        data: {
          access_token,
          study_contract_id: contractId,
          document_reason_id: current_document_reason_id,
        },
      };
      const data = await StudentService.send(request, () => {});
      setAllowedStartDates({
        original: data.start_dates,
        formated: data.start_dates.map((el) => (el = new Date(el))),
      });
      setStartDate(null);
      setAllowedEndDates(null);
      setEndDate(null);
    }
  }
  async function getEndDates(start_date) {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/academic/end_dates",
        data: {
          access_token,
          study_contract_id: contractId,
          document_reason_id: stateData.current_document_reason_id,
          start_date,
        },
      };
      const data = await StudentService.send(request, () => {});

      setAllowedEndDates({
        original: data.end_dates,
        formated: data.end_dates.map((el) => (el = new Date(el))),
      });
    }
  }

  async function getDocumentList(document_reason_id, state = stateData) {
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/academic/documents_list/get",
        data: {
          access_token,
          study_contract_id: contractId,
          document_reason_id,
          event_guid: state.academic_leave_event.event_guid,
        },
      };
      const data = await StudentService.send(request, () => {});
      setRequiredDocs(data.documents);
    }
  }

  async function getStatement() {
    if (disabled || isSaveMandatory) return;
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/academic/statement",
        data: {
          access_token,
          study_contract_id: contractId,
          event_guid: stateData.academic_leave_event.event_guid,
        },
      };
      setStatementLoading(true);
      const res = await StudentService.send(request, (res) => {});
      if (!res.errors) {
        window.open(res.url);
      } else if (res.errors) {
        const errorEvent = new ErrorEvent("error", { error: res });
        window.dispatchEvent(errorEvent);
      }
      setStatementLoading(false);
    }
  }
  async function createEvent() {
    setCreateEventBtnLoading(true);
    if (access_token) {
      const request = {
        method: "post",
        path: "/student/applications/academic/event/create",
        data: {
          access_token,
          study_contract_id: contractId,
        },
      };
      const res = await StudentService.send(request, (res) => {});
      if (!res.errors) {
        getCertificatesMenu();
      } else if (res.errors) {
        const errorEvent = new ErrorEvent("error", { error: res });
        window.dispatchEvent(errorEvent);
      }
      setCreateEventBtnLoading(false);
    }
  }

  function onStartDateChange(date) {
    setIsSaveMandatory(true);

    const startdateindex = allowedStartDates.formated.findIndex(
      (el) => el.getTime() === date.getTime(),
    );
    getEndDates(allowedStartDates.original[startdateindex]);
    setStartDate(date);
    setDates((prev) => ({
      ...prev,
      start_date: allowedStartDates.original[startdateindex],
    }));
    setEndDate(null);
  }

  function onEndDateChange(date) {
    const endDateindex = allowedEndDates.formated.findIndex(
      (el) => el.getTime() === date.getTime(),
    );
    setDates((prev) => ({
      ...prev,
      end_date: allowedEndDates.original[endDateindex],
    }));
    setEndDate(date);
    setIsCalendarShow(false);
  }
  const isStartDateAllowed = (date) => {
    return allowedStartDates.formated.some((allowedDate) => {
      const allowed = new Date(allowedDate);
      return (
        date.getFullYear() === allowed.getFullYear() &&
        date.getMonth() === allowed.getMonth() &&
        date.getDate() === allowed.getDate()
      );
    });
  };
  const isEndDateAllowed = (date) => {
    return allowedEndDates.formated.some((allowedDate) => {
      const allowed = new Date(allowedDate);
      return (
        date.getFullYear() === allowed.getFullYear() &&
        date.getMonth() === allowed.getMonth() &&
        date.getDate() === allowed.getDate()
      );
    });
  };

  const handleReasonChange = async (e) => {
    setIsCalendarShow(false);
    setIsSaveMandatory(true);
    setReasonId(e.target.value);
    const selectedReason = reasons.find(
      (reason) => reason.document_reason_id == e.target.value,
    );
    setExplanationCommentValue("");
    setExplanations(selectedReason.explanations);
    setExplanationId("");
    await getStartDates(selectedReason.document_reason_id);
    setRequiredDocs(null);
    setStateData((prev) => {
      delete prev.explanation_comment_needed;
      delete prev.explanation_id;
      return {
        ...prev,
        current_document_reason_id: +e.target.value,
      };
    });
    setDates(null);
    getDocumentList(+e.target.value);
  };

  const handleExplanationChange = (e) => {
    setIsSaveMandatory(true);

    const explanation = JSON.parse(e.target.value);

    const explanation_id = explanation.explanation_id;
    const selectedExplanation_id = explanations.find(
      (explanation) => explanation.explanation_id == explanation_id,
    );
    const explanation_comment_needed = explanation.explanation_comment_needed;
    setExplanationId(JSON.stringify(selectedExplanation_id));
    setStateData((prev) => {
      return {
        ...prev,
        explanation_id,
        explanation_comment_needed,
      };
    });
  };
  const handleFileChange = async (event, doc, idx) => {
    setFileUploadLoadingIds(idx);
    const newFiles = [...event.target.files];
    for (const file of newFiles) {
      const fileData = {
        access_token,
        study_contract_id: contractId,
        source_filename: file.name,
        file,
        event_guid: stateData.academic_leave_event.event_guid,
        document_type_id: doc.type_id,
        scan_id: doc.scan_id,
        progress_fn: (p) => {
          console.log(p);
        },
      };

      try {
        const res = await add_attachment(fileData);

        const updatedData = structuredClone(requiredDoc);
        updatedData[idx].pages.push(res);
        setRequiredDocs(updatedData);
      } catch (error) {
        console.error(error);
      } finally {
        setFileUploadLoadingIds(null);
      }
    }
    event.target.value = null;
  };
  const handleFileUpdate = async (event, doc, idx, page_id, i) => {
    if (disabled) return;
    const newFiles = [...event.target.files];
    for (const file of newFiles) {
      const fileData = {
        access_token,
        study_contract_id: contractId,
        source_filename: file.name,
        file,
        event_guid: stateData.academic_leave_event.event_guid,
        document_type_id: doc.type_id,
        scan_id: doc.scan_id,
        page_id,
        progress_fn: (p) => {
          console.log(p);
        },
      };

      try {
        setFileUploadLoadingIds(idx);
        const res = await update_attachment(fileData);
        const updatedRuquiredDocs = [...requiredDoc];
        const mime_type =
          file.type === "application/pdf"
            ? 6
            : file.type === "image/jpeg"
              ? 8
              : file.type === "image/png" && 7;
        updatedRuquiredDocs[idx].pages[i].mime_type_id = mime_type;

        setRequiredDocs(updatedRuquiredDocs);
        const updatedData = structuredClone(requiredDoc);
        updatedData[idx].pages.push(res);
      } catch (error) {
        console.error(error);
      } finally {
        console.log();

        setFileUploadLoadingIds(null);
      }
    }
  };
  const removeFile = ({ idx, i, scan_id }) => {
    if (disabled) return;
    const updatedData = structuredClone(requiredDoc);
    updatedData[idx].pages.splice(i, 1);
    // delete updatedData[idx].pages[i];
    setRequiredDocs(updatedData);
  };

  async function handleSaveState(action_id) {
    // const hasErrors = validateForm();
    // if (hasErrors) {
    //   return;
    // }
    setLoadState("loading");
    const documents = [];
    requiredDoc.forEach((el) => {
      if (el.pages.length > 0) {
        documents.push({ scan_id: el.scan_id, state_id: el.state_id });
      }
    });

    const request = {
      method: "post",
      path: "/student/applications/academic/event/update",
      data: {
        access_token,
        event_guid: stateData.academic_leave_event.event_guid,
        action: action_id,
        document_reason_id: stateData.current_document_reason_id,
        reason_explanation_id: stateData.explanation_id,
        reason_explanation_comment: explanationCommentValue,
        start_date: dates.start_date,
        end_date: dates.end_date,
        documents: documents,
        study_contract_id: contractId,
      },
    };
    if (!stateData.explanation_comment_needed || !explanationCommentValue) {
      delete request.data.reason_explanation_comment;
    }

    // if (bool) setLoadState("loading");
    const res = await StudentService.send(request, (res) => {});
    if (!res.errors) {
      setLoadState(res.message);

      await getCertificatesMenu();
      // setTimeout(() => {
      //   setLoadState(null);
      // }, 15000);
    }
    if (res.errors) {
      const errorEvent = new ErrorEvent("error", { error: res });
      window.dispatchEvent(errorEvent);
      setLoadState(null);
    }
  }
  const validateForm = () => {
    const errors = [];

    if (!reasonId) {
      errors.push("Не выбрано основание ухода");
    }

    if (explanations?.length > 0 && !explanationId) {
      errors.push("Не выбрано пояснение");
    }

    if (
      stateData.explanation_comment_needed &&
      !explanationCommentValue?.trim()
    ) {
      errors.push("Не заполнен комментарий");
    }

    if (!startDate && !endDate) {
      errors.push("Не выбран период отпуска");
    } else if (!startDate) {
      errors.push("Не выбрана начальная дата отпуска");
    } else if (!endDate) {
      errors.push("Не выбрана конечная дата отпуска");
    }
    if (requiredDoc?.length) {
      requiredDoc.forEach((doc) => {
        if (doc.is_mondatory && (!doc.pages || doc.pages.length === 0)) {
          errors.push(`Не загружен документ: ${doc.name}`);
        }
      });
    }
    if (errors.length > 0) {
      const event = new ErrorEvent("error", {
        error: { error_type: "other", errors: errors },
      });
      window.dispatchEvent(event);
    }
    return errors.length > 0;
  };
  useEffect(() => {
    getCertificatesMenu();
  }, []);
  useEffect(() => {
    if (allowedStartDates?.formated.length > 0) {
      setActiveStartMonth(new Date(allowedStartDates.formated[0]));
    }
  }, [allowedStartDates]);

  useEffect(() => {
    if (allowedEndDates?.formated.length > 0) {
      setActiveEndMonth(new Date(allowedEndDates.formated[0]));
    }
  }, [allowedEndDates]);
  // useEffect(() => {
  //   if (requiredDoc) {
  //     let someMandatoryIsNotLoaded = false;
  //     for (const element of requiredDoc) {
  //       if (element.is_mondatory && element.pages.length < 1) {
  //         someMandatoryIsNotLoaded = true;
  //         break;
  //       }
  //     }
  //     setMandatoryDocLoaded(!someMandatoryIsNotLoaded);
  //   }
  // }, [requiredDoc]);
  if (response?.errors) {
    if (response?.error_type !== "auth" && response?.error_type !== "info") {
      return <ErrataWidget errata={response} />;
    }
    if (response?.error_type === "info")
      return <ErrataViewInfo errata={response} />;
  }
  if (!response || !stateData)
    return (
      <WidgetFrame
        type="blue"
        icon="loading"
        title="Личное заявление студента на отпуск"
      ></WidgetFrame>
    );

  return (
    <WidgetFrame
      type="blue"
      icon="survey"
      title="Личное заявление студента на отпуск"
    >
      {Object.values(stateData.academic_leave_event).length < 1 && (
        <div>
          {createEventBtnLoading ? (
            <Loader />
          ) : (
            <button onClick={createEvent} className={cls.buttonBright}>
              Заполнить заявление
            </button>
          )}
        </div>
      )}
      {Object.values(stateData.academic_leave_event).length > 0 && (
        <>
          Основание ухода
          {reasons && (
            <>
              <select
                disabled={disabled}
                value={reasonId}
                defaultValue=""
                className={`${cls.datePeriod} ${disabled ? cls.disabled : ""}`}
                onChange={handleReasonChange}
              >
                <>
                  <option value="" disabled hidden>
                    Не выбрано
                  </option>
                  {reasons.map(
                    ({ document_reason_text, document_reason_id }) => (
                      <option
                        value={document_reason_id}
                        key={document_reason_id}
                      >
                        {document_reason_text}
                      </option>
                    ),
                  )}
                </>
              </select>
            </>
          )}
        </>
      )}
      {explanations && explanations.length > 0 && (
        <>
          <select
            disabled={disabled}
            defaultValue=""
            className={cls.datePeriod}
            onChange={handleExplanationChange}
            value={explanationId}
          >
            <>
              <option value="" hidden>
                Не выбрано
              </option>
              {explanations.map((explanation) => (
                <option
                  value={JSON.stringify(explanation)}
                  key={explanation.explanation_id}
                >
                  {explanation.explanation_text}
                </option>
              ))}
            </>
          </select>
        </>
      )}
      {stateData.explanation_comment_needed && (
        <input
          disabled={disabled}
          className={cls.explanationComment}
          value={explanationCommentValue}
          onChange={(e) => setExplanationCommentValue(e.target.value)}
        />
      )}
      {allowedStartDates && (
        <>
          Укажите период отпуска
          <div
            onClick={() => {
              if (!disabled) setIsCalendarShow((prev) => !prev);
            }}
            className={`${cls.datePeriod} ${disabled ? cls.disabled : ""}`}
          >
            {startDate && startDate.toLocaleDateString()}{" "}
            <Icon name="next_date" />
            {endDate && endDate.toLocaleDateString()}
          </div>
        </>
      )}
      {isCalendarShow && (
        <>
          <div
            style={{
              color: "rgb(255, 0, 0)",
              textAlign: "justify",
            }}
          >
            Выбор в календаре даты начала АО определен с учетом необходимого
            времени для оформления и направления Вами оригинала заявления и
            прилагаемых к нему документов в образовательную организацию для
            рассмотрения. Оформите все документы в ближайшее время и направьте
            их в образовательную организацию, чтобы документы установленным
            порядком были рассмотрены в образовательной организации и решение
            было принято не позднее указанной Вами даты начала АО
          </div>
          <div style={{ display: "flex" }}>
            <div>
              <div style={{ marginBottom: "1rem" }}>
                Выберите начало отпуска
              </div>

              <Calendar
                selectRange={false}
                onChange={onStartDateChange}
                value={startDate}
                tileDisabled={({ date }) => !isStartDateAllowed(date)}
                activeStartDate={activeStartMonth}
                onActiveStartDateChange={({ activeStartDate }) =>
                  setActiveStartMonth(activeStartDate)
                }
              />
            </div>

            {allowedEndDates && (
              <div style={{ marginLeft: "1rem", alignSelf: "end" }}>
                <div style={{ marginBottom: "1rem" }}>
                  Выберите окончание отпуска
                </div>
                <Calendar
                  selectRange={false}
                  onChange={onEndDateChange}
                  value={endDate}
                  tileDisabled={({ date }) => !isEndDateAllowed(date)}
                  activeStartDate={activeEndMonth}
                  onActiveStartDateChange={({ activeStartDate }) =>
                    setActiveEndMonth(activeStartDate)
                  }
                />
              </div>
            )}
          </div>
        </>
      )}
      {statementLoading ? (
        <Loader />
      ) : (
        stateData.academic_leave_event.event_guid && (
          <a
            className={`${cls.sample} ${disabled || isSaveMandatory ? cls.disabled : ""}`}
            disabled={disabled || isSaveMandatory}
            onClick={getStatement}
            title={
              !startDate || !endDate
                ? "Выберите даты начала и окончания"
                : isSaveMandatory
                  ? "Для скачивания шаблона заявления сначала сохраните заявку"
                  : ""
            }
          >
            Шаблон заявления
          </a>
        )
      )}

      {requiredDoc && (
        <>
          {requiredDoc.map((el, idx) => {
            return (
              <div key={`${el.doc_name_id}-${idx}`}>
                <div>
                  {el.is_mondatory && <span className={cls.require}>*</span>}
                  {el.name}
                </div>
                <input
                  disabled={disabled}
                  className={cls.inputHidden}
                  id={`input__file-${el.scan_id}`}
                  type="file"
                  multiple
                  onChange={(e) => handleFileChange(e, el, idx)}
                  accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
                />
                <label
                  className={`${cls.inputLabel} ${disabled ? cls.disabled : ""}`}
                  htmlFor={`input__file-${el.scan_id}`}
                >
                  Загрузить
                </label>
                {/* <div className={el.is_mandatory && cls.require}>
                Мин. кол-во стр. &nbsp;{el.page_count_min}
              </div> */}
                {fileUploadLoadingIds === idx ? (
                  <LinearLoader />
                ) : (
                  el.pages.length > 0 && (
                    <>
                      Приложения:
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "1.5rem",
                          alignItems: "baseline",
                        }}
                      >
                        {el.pages.map((page, i) => {
                          return (
                            <div key={i} className={cls.uploadedFile}>
                              <SinglePage
                                el={el}
                                idx={idx}
                                i={i}
                                page={page}
                                scan_id={el.scan_id}
                                event_guid={
                                  stateData.academic_leave_event.event_guid
                                }
                                removeFile={removeFile}
                                handleFileUpdate={handleFileUpdate}
                                disabled={disabled}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )
                )}
              </div>
            );
          })}
          {isSaveMandatory && (
            <div style={{ color: "rgb(255, 0, 0)", textAlign: "justify" }}>
              При загрузке заявления убедитесь, что Вы используете актуальный
              бланк Вашей образовательной организации. Вы можете воспользоваться
              кнопкой «Сохранить» для сохранения внесенных Вами данных в заявку,
              Ваше заявление будет сформировано автоматически на основании
              сохраненных данных при нажатии на «Шаблон заявления». Вам его
              нужно будет распечатать, подписать и загрузить в данную заявку.
            </div>
          )}
        </>
      )}

      <div>
        {loadState === "loading" ? (
          <Loader />
        ) : (
          stateData.academic_leave_event?.event_guid &&
          requiredDoc &&
          stateData.current_document_reason_id &&
          dates &&
          dates.start_date &&
          dates.end_date && (
            <div style={{ display: "flex", gap: "1rem" }}>
              {stateData.academic_leave_event?.details?.actions?.map(
                (action) => {
                  return (
                    <button
                      key={action.action_id}
                      onClick={() => handleSaveState(action.action_id)}
                      className={`${
                        stateData.academic_leave_event.details.can_edit &&
                        fileUploadLoadingIds === null
                          ? cls.buttonBright
                          : cls.buttonDisable
                      }`}
                      disabled={
                        !stateData.academic_leave_event.details.can_edit ||
                        fileUploadLoadingIds !== null
                      }
                    >
                      {action.action_description}
                    </button>
                  );
                },
              )}
            </div>
          )
        )}
      </div>
      {loadState !== "loading" && loadState !== null && (
        <Snackbar
          // autoHideDuration={6000}
          open
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          ContentProps={{
            sx: {
              justifyContent: "center",
            },
          }}
        >
          <Alert
            onClose={() => setLoadState(null)}
            severity="success"
            variant="filled"
            closeText="Закрыть"
            icon={false}
            sx={{ width: "100%" }}
          >
            {loadState}
          </Alert>
        </Snackbar>
      )}
    </WidgetFrame>
  );
}

export default AcademicVacation;
